import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function PrivateRoute({ children }) {
  const { currentUser, is2FAVerified } = useAuth();

  // Must be logged in AND 2FA Verified
  if (!currentUser || !is2FAVerified) {
    return <Navigate to="/login" />;
  }

  return children;
}